let openDialogState = false
let currentOpenDialog = null
const btnOpenDialog = document.querySelectorAll('.open-dialog')
const btnCloseDialog = document.querySelectorAll('.close-dialog')

btnOpenDialog.forEach((btn) => {
	btn.addEventListener('click', () => {
		const dialogName = btn.dataset.dialogName
		if (dialogName) {
			const dialog = document.querySelector(`div.dialog[data-dialog-name="${dialogName}"]`)
			
			if (dialog) {
				openDialog(dialog)
			}
		}
	})
})

btnCloseDialog.forEach((btn) => {
	const dialogName = btn.closest('div.dialog').dataset.dialogName
	
	if (dialogName) {
		btn.addEventListener('click', () => {
			const dialog = document.querySelector(`div.dialog[data-dialog-name="${dialogName}"]`)
			
			if (dialog) {
				closeDialog(dialog)
			}
		})
	}
})

document.addEventListener('keydown', () => {
	if (openDialogState) {
		if (event.key === 'Escape') {
			if (currentOpenDialog) {
				closeDialog(currentOpenDialog)
			}
		}
	}
})

function openDialog(dialogEl) {
	dialogEl.classList.add("dialog-open")
	jQuery(dialogEl).appendTo('.wrapper')
	
	openDialogState = true
	currentOpenDialog = dialogEl

	document.querySelector('body').setAttribute('style', 'overflow: hidden;')
}

function closeDialog(dialogEl) {
	dialogEl.classList.remove("dialog-open")

	openDialogState = false
	currentOpenDialog = null

	document.querySelector('body').removeAttribute('style')
}